const ReplaceAllContent = (bfString, afString, content) => {
    var arrContent = content.split(bfString);
    var resContent = '';
    for(var ac=0; ac<arrContent.length; ac++) {
        if(ac > 0) { resContent += afString; }
        resContent += arrContent[ac];
    }
    return (resContent);
}
export default ReplaceAllContent;